import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { MessageType } from './Types';
import { getList } from './api';

interface IMsgPanelSlicerState {
	loading: string;
	error?: string;
	isActive: boolean;
	messages: Array<MessageType>;
	count: number;
	page: number;
}

const initialState: IMsgPanelSlicerState = {
	loading: '',
	error: '',
	isActive: false,
	messages: [],
	count: 0,
	page: 0,
};

export const updateList = createAsyncThunk(
	'messagePanel/updateList',
	async () => {
		const response = await getList({
			sortCriteria: { sortBy: 'createdAt', sortAsc: false },
			pagingModel: { page: 1, pageSize: 3 },
		});
		return response;
	},
);

export const msgPanelSlicer = createSlice({
	name: 'messagePanel',
	initialState,
	reducers: {
		setShowPanel: (state, data: PayloadAction<boolean>) => {
			state.isActive = data.payload;
		},
		changeCollapsed: (state, data: PayloadAction<string>) => {
			const index = state.messages.findIndex((m) => {
				return m.recID === data.payload;
			});
			if (index === -1) {
				updateList();
			}
			const newList = [...state.messages];
			newList[index].collapsed = !state.messages[index].collapsed;
			state.messages = newList;
		},
		addPushMessage: (state, data: PayloadAction<MessageType>) => {
			console.log(data);
			state.messages.unshift(data.payload);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(updateList.pending, (state) => {
			state.loading = 'pending';
		});
		builder.addCase(updateList.fulfilled, (state, action) => {
			if (action.payload) {
				return {
					...state,
					messages: [...action.payload.list],
					count: action.payload.count,
					page: action.payload.page,
					loading: 'succeeded',
				};
			}
		});
		builder.addCase(updateList.rejected, (state, action) => {
			state.error = action.error.message;
			state.loading = 'failed';
		});
	},
});

export const getState = (store: RootState): IMsgPanelSlicerState => {
	return store.messagePanel;
};
export const { setShowPanel, changeCollapsed, addPushMessage } =
	msgPanelSlicer.actions;
export default msgPanelSlicer;
